import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputLabelContainer } from '../../../../../common/components/form/label/containers/input-label.container';
import { currency, format } from '../../../../../common/services/common.service';


export default function SubscriptionTransactionInfoComponent ({subscriptionInfo}: any) {
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
      <div>
        <InputLabelContainer label="Name" />
        <InputLabelContainer label={subscriptionInfo?.Name} />
     </div>
     <div>
          <InputLabelContainer
              label="FirstName"
          />
          <InputLabelContainer
              label={subscriptionInfo?.FirstName}
          />
    </div>
    <div>
          <InputLabelContainer
              label="LastName"
          />
          <InputLabelContainer
              label={subscriptionInfo?.LastName}
          />
     </div>
     <div>
        <InputLabelContainer label="OwnerName" />
        <InputLabelContainer label={subscriptionInfo?.OwnerName} />
     </div>
     <div>
         < InputLabelContainer
              label="User Profile"
          />
          <InputLabelContainer
              label={subscriptionInfo?.UserProfileId}
          />
       </div>
     <div>
        <InputLabelContainer label="Validity" />
        <InputLabelContainer label={subscriptionInfo?.Validity} />
     </div>
     <div>
         < InputLabelContainer
              label="Start Date"
          />
          <InputLabelContainer
              label={format(subscriptionInfo?.StartDateUtc)}
          />
       </div>
       <div>
         < InputLabelContainer
              label="End Date"
          />
          <InputLabelContainer
              label={format(subscriptionInfo?.EndDateUtc)}
          />
      </div>
   
     <div>
         < InputLabelContainer
              label="CurrencyCode"
          />
          <InputLabelContainer
              label={subscriptionInfo?.CurrencyCode}
          />
      </div>
     <div>
        <InputLabelContainer label="Amount" />
        <InputLabelContainer label={currency(subscriptionInfo?.Amount ||0)} />
     </div>
     <div>
        <InputLabelContainer label="Description" />
        <InputLabelContainer label={subscriptionInfo?.Description} />
     </div>

  </div>
  }
  expandedPanel="basicInfo"
  headerTitle="Basic Info"
/>
<AccordionContainer
    child={
        <div className="h-auto w-full bg-white  p-4 rounded">
        <table className="w-full text-xs bg-red-50">
            <thead className="w-full border-y border-black border-opacity-20">
                <tr className="w-full text-left h-12">
                    <th className="px-3">S.NO</th>
                    <th className="px-3">Commerce SubscriptionId</th>
                    <th className="px-3">No Of Services</th>
                    <th className="px-3">Balance Services</th>
                    <th className="px-3">Service Used</th>
                    <th className="px-3">OrderId</th>
                    <th className="px-3">CreatedOn</th>
                </tr>
            </thead>
            <tbody className="w-full h-auto">
                {subscriptionInfo?.DBaaSSubscriptionTransactions?.map((TranscationItems: any, index: any) => (
                    <tr key={index} className="cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white">
                        <td className="px-3">{index + 1}</td>
                        <td className="px-3">{TranscationItems?.CommerceSubscriptionId}</td>
                        <td className="px-3">{TranscationItems?.NoOfServices}</td>
                        <td className="px-3">{TranscationItems?.BalanceServices}</td>
                        <td className="px-3">{TranscationItems?.ServicesUsed}</td>
                        <td className="px-3">{TranscationItems?.OrderId}</td>
                        <td className="px-3">{format(TranscationItems?.CreatedOnUtc)}</td>
                        
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
   }
   expandedPanel="CommerceSubscriptionTransactions"
   headerTitle="Commerce Subscription Transactions"
 />
        </>
  )
}